import React from 'react';
// import { Component } from 'react';
import { Link } from "gatsby"
import moment from "moment/moment"
// import AuthorIcon from "./icons/author"
// import DateIcon from "./icons/date"
// import CategoryIcon from "./icons/category"
// import TagIcon from "./icons/tag"
// import { navigate } from "gatsby";
// import { window, document } from 'browser-monads';

const PostFooterMeta = ({ author, date, categories, tags, uri, link, externalLink }) => (
  <footer className="entry-footer">

  <div style={{display: "flex", margin: "auto"}}>
          <a href={externalLink} style={{display: externalLink?"flex":"none", margin:"auto"}}>
          <button style={{height:"60px", margin:"auto", width: "90%", borderRadius: "7px",background: "linear-gradient(53.35deg, #EE3D49 0%, #CB356B 100%)"}}><h2 style={{fontFamily: "aktiv-grotesk", fontSize: "19px",color: "white"}}>Prendi il biglietto</h2></button>
          </a>
  </div>

    <span className="byline"  style={{display: "none"}}>
      {/*}<AuthorIcon />*/}
    </span>
    <span className="posted-on" style={{display: "none"}}>
      {/*}<DateIcon />*/}
      <Link
        to={`/${uri}`}
        rel="bookmark"
      >
        <time
          className="entry-date published updated"
          dateTime="2019-02-25T17:37:06+00:00"
        >
          {moment(date).format(`MMMM D, YYYY`)}
        </time>
      </Link>
    </span>
  </footer>
)

export default PostFooterMeta
